export const resolveContentPadding = (
    useContentPaddingX: boolean,
    useContentPaddingY: boolean
): Record<string, boolean> => {
    if (useContentPaddingX && useContentPaddingY) {
        return { 'p-4': true };
    }

    if (useContentPaddingX) {
        return { 'px-4': true };
    }

    if (useContentPaddingY) {
        return { 'py-4': true };
    }

    return {};
};
